module.exports = __webpack_public_path__ + "static/media/team4.8b30278c.png";